import { useNavigate } from "react-router-dom";
import GridView from "../../components/controls/GridView/GridView";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import { MenuItem } from "../../models/menu";
import { FixedDeposit } from "../../services/fixedDepositService";
import { useState } from "react";
import Frame from "../../components/controls/Frame/Frame";
import FormModal from "../../components/controls/FormModal";
import FormCommand from "../../components/controls/FormCommand";

function getFixedDepositContextMenu(): MenuItem<FixedDeposit>[] {
  return [
    {
      name: "Edit",
      onClick: (d) => {
        alert(d.accountName);
      },
    },
    {
      name: "Delete",
      onClick: (d) => {
        alert(d.accountName);
      },
    },
    {
      name: "Post",
      onClick: (d) => {
        alert("post ft");
      },
    },
    {
      name: "Force to Mature",
      onClick: (d) => {
        alert("Force to mature");
      },
    },
    {
      name: "Liquidate",
      onClick: (d) => {
        alert("Liquidate");
      },
    },
    {
      name: "RollOver",
      onClick: (d) => {
        alert("Rollover");
      },
    },
  ];
}

export interface FixedDepositListingPageProps {}

export const FixedDepositListingPage = (
  props: FixedDepositListingPageProps
) => {
  const [fixedDeposit, setFixedDeposit] = useState<FixedDeposit>();

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <h4>
              Fixed Deposit{" "}
              <small className="text-secondary">(Investment)</small>
            </h4>
            <GridView
              showAddButton={true}
              showSearchBar={true}
              keys={["name"]}
              name={"lstTransactions"}
              onAddRecord={() => setFixedDeposit({})}
            />
          </Frame>
        </div>
      </div>

      {fixedDeposit && (
        <FormModal onClose={() => setFixedDeposit(undefined)}>
          <FixedDepositForm />
        </FormModal>
      )}
    </>
  );
};

export interface FixedDepositFormProps {}

export function FixedDepositForm(props: FixedDepositFormProps) {
  return (
    <div className="row">
      <div className="col">
        <FindAccount id="findAccount" text="Account" />
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label htmlFor="startDate" className="control-label">
                Start Date
              </label>
              <input
                type="date"
                name="startDate"
                id="startDate"
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="duration" className="control-label">
                Duration <small>(Days)</small>
              </label>
              <input
                type="number"
                name="duration"
                id="duration"
                className="form-control form-control-sm"
              />
            </div>
          </div>

          <div className="col-4">
            <div className="form-group">
              <label htmlFor="amount" className="control-label">
                Amount
              </label>
              <input
                type="number"
                name="amount"
                id="amount"
                className="form-control form-control-sm"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label htmlFor="rate" className="control-label">
                Rate
              </label>
              <input
                type="number"
                name="rate"
                id="rate"
                className="form-control form-control-sm"
              />
            </div>
          </div>
        </div>

        <FindAccount text="Interest Account" id="interestAccount" />
        <FindAccount text="Liquidation Account" id="liquidationAccount" />
        <FindAccount text="Penalty Account" id="penaltyAccount" />

        <div className="form-group">
          <label htmlFor="instruction" className="control-label">
            Instruction <small>(when matured)</small>
          </label>
          <select
            name="instruction"
            id="instruction"
            className="form-control form-control-sm"
          >
            <option value="">Select Instruction</option>
            <option value="1">Liquidate</option>
            <option value="2">RollOver</option>
          </select>
        </div>

        <FormCommand />
      </div>
    </div>
  );
}
